import React, {useEffect} from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {
  FiTarget,
  FiUsers,
  FiShield,
  FiCheckCircle,
  FiArrowLeft,
} from "react-icons/fi";

const AboutPage = () => {
  const { pathname } = useLocation();

  const values = [
    {
      icon: FiTarget,
      title: "شفافیت",
      desc: "قیمت‌گذاری شفاف و بدون هزینه پنهان در تمام مراحل خرید.",
    },
    {
      icon: FiShield,
      title: "اعتماد",
      desc: "همکاری با تأمین‌کنندگان معتبر و تضمین کیفیت محصولات.",
    },
    {
      icon: FiUsers,
      title: "پشتیبانی",
      desc: "تیم پشتیبانی پاسخگو در تمامی مراحل انتخاب و خرید.",
    },
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <div className="px-4 py-6 md:px-6 md:py-8 lg:px-8">
      <div className="mx-auto flex max-w-7xl flex-col gap-8">
        {/* Hero */}
        <section className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div
              className="bg-gradient-to-l from-[#1E3A5F] to-[#2B5388] px-4 py-8 text-center text-white md:px-8 md:py-12">
            <span
                className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-medium text-[#FFC107]">
              <FiUsers className="h-3.5 w-3.5"/>
              درباره ما
            </span>

            <h1 className="mt-4 text-lg font-bold leading-8 text-white md:text-2xl lg:text-3xl">
              با ما بیشتر آشنا شوید
            </h1>

            <p className="mx-auto mt-3 max-w-2xl text-sm leading-7 text-white/80 md:text-base text-justify">
              ما با هدف ارائه تجربه‌ای مطمئن، سریع و شفاف در خرید مصالح و کالای
              ساختمانی در کنار شما هستیم.
            </p>
          </div>
        </section>

        <section className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5">
          <div className="border-b border-gray-100 pb-4">
            <h2 className="text-sm font-semibold text-gray-800 sm:text-base">
              معرفی شرکت
            </h2>
          </div>

          <div className="mt-4 space-y-4 text-sm leading-8 text-gray-700 sm:text-base text-justify">
            <p>
              تأمین کالا یکی از بخش‌های مهم و در عین حال پیچیده در صنعت
              ساخت‌وساز است. تنوع بالای کالاها، تعداد زیاد تأمین‌کنندگان،
              تفاوت قیمت و شرایط فروش، فاصله جغرافیایی، محدودیت اطلاعات و
              دشواری پیگیری سفارش، همگی می‌توانند فرآیند تأمین را زمان‌بر و
              پرهزینه کنند. ایده شکل‌گیری این بازارگاه از همین مسئله آغاز شد.
            </p>

            <p>
              در سال‌های گذشته، بخشی از فعالیت پژوهشی ما بر زنجیره تأمین
              ساخت‌وساز و مسائل مرتبط با آن متمرکز بوده است و حاصل این فعالیت،
              نگارش و انتشار پنج مقاله علمی در این حوزه بوده است. تجربه پژوهش و
              شناخت مسائل واقعی زنجیره تأمین، این فرصت را ایجاد کرد تا به جای
              نگاه صرفاً فروشگاهی، فرآیند تأمین کالای ساختمانی را از زاویه‌ای
              گسترده‌تر ببینیم؛ از پیدا کردن و انتخاب تأمین‌کننده تا خرید، حمل،
              تحویل و خدمات پس از فروش.
            </p>

            <p>
              بازارگاه حاضر با همین رویکرد شکل گرفته است: استفاده از فناوری
              برای ساده‌تر و کارآمدتر کردن زنجیره تأمین کالای ساختمانی.
            </p>
          </div>
        </section>

        {/* تأمین سریع‌تر، دقیق‌تر و آسان‌تر */}
        <section className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5">
          <div className="border-b border-gray-100 pb-4">
            <h2 className="text-sm font-semibold text-gray-800 sm:text-base">
              تأمین سریع‌تر، دقیق‌تر و آسان‌تر
            </h2>
          </div>

          <div className="mt-4 space-y-4 text-sm leading-8 text-gray-700 sm:text-base text-justify">
            <p>
              هدف ما این است که مشتری برای تأمین یک کالای ساختمانی، زمان و
              انرژی کمتری صرف جست‌وجو و هماهنگی کند.
            </p>
            <p>
              در بازارگاه، اطلاعات کالاها و تأمین‌کنندگان در یک بستر متمرکز
              قرار می‌گیرد تا مشتری بتواند گزینه‌های موجود را راحت‌تر پیدا و
              مقایسه کند و با اطلاعات بهتر، تصمیم بگیرد. نتیجه مورد انتظار،
              کاهش زمان جست‌وجو، کاهش هزینه‌های معاملاتی و افزایش دقت در فرآیند
              تأمین است.
            </p>
          </div>
        </section>

        {/* تأمین‌کنندگان منتخب */}
        <section className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5">
          <div className="border-b border-gray-100 pb-4">
            <h2 className="text-sm font-semibold text-gray-800 sm:text-base">
              تأمین‌کنندگان منتخب
            </h2>
          </div>

          <div className="mt-4 space-y-4 text-sm leading-8 text-gray-700 sm:text-base text-justify">
            <p>
              یکی از چالش‌های خرید در بازار سنتی، پیدا کردن تأمین‌کننده مناسب و
              اطمینان از کیفیت و شرایط معامله است.
            </p>
            <p>
              ما با حضور تأمین‌کنندگان منتخب تلاش می‌کنیم این مرحله را برای
              مشتری ساده‌تر کنیم. هدف، ایجاد بستری است که در آن مشتری به جای
              جست‌وجوی پراکنده در بازار، بتواند از میان تأمین‌کنندگان موجود،
              گزینه‌های مناسب‌تری را شناسایی و انتخاب کند.
            </p>
            <p>
              این رویکرد همچنین به تأمین‌کنندگان کمک می‌کند تا محصولات و ظرفیت
              عرضه خود را به مشتریانی فراتر از بازار محلی خود معرفی کنند.
            </p>
          </div>
        </section>

        {/* عبور از محدودیت جغرافیا */}
        <section className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5 text-justify">
          <div className="border-b border-gray-100 pb-4">
            <h2 className="text-sm font-semibold text-gray-800 sm:text-base">
              عبور از محدودیت جغرافیا
            </h2>
          </div>

          <div className="mt-4 space-y-4 text-sm leading-8 text-gray-700 sm:text-base">
            <p>
              در بازار سنتی، فاصله جغرافیایی می‌تواند دسترسی مشتری به بسیاری از
              تأمین‌کنندگان را محدود کند.
            </p>
            <p>
              بازارگاه این محدودیت را تا حد زیادی کاهش می‌دهد. مشتری می‌تواند
              به تأمین‌کنندگانی دسترسی پیدا کند که شاید در حالت عادی به دلیل
              فاصله، از گزینه‌های خرید او خارج باشند. به این ترتیب، دامنه
              انتخاب گسترده‌تر می‌شود و امکان مقایسه گزینه‌های بیشتری برای
              تأمین کالا فراهم می‌شود.
            </p>
          </div>
        </section>

        {/* پیگیری ساده‌تر سفارش */}
        <section className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5 text-justify">
          <div className="border-b border-gray-100 pb-4">
            <h2 className="text-sm font-semibold text-gray-800 sm:text-base">
              پیگیری ساده‌تر سفارش
            </h2>
          </div>

          <div className="mt-4 space-y-4 text-sm leading-8 text-gray-700 sm:text-base">
            <p>
              فرآیند تأمین با ثبت سفارش به پایان نمی‌رسد. وضعیت سفارش، زمان
              آماده‌سازی، حمل، تحویل و مسائل احتمالی پس از خرید نیز بخش مهمی از
              تجربه تأمین هستند.
            </p>
            <p>
              ما تلاش کرده‌ایم این فرآیند تا حد امکان شفاف و قابل پیگیری باشد
              تا مشتری بتواند وضعیت سفارش خود را راحت‌تر دنبال کند و در صورت
              نیاز، خدمات و پشتیبانی مرتبط با سفارش را از طریق یک بستر مشخص
              دریافت کند.
            </p>
          </div>
        </section>

        {/* حمل‌ونقل و تحویل مطمئن‌تر */}
        <section className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5 text-justify">
          <div className="border-b border-gray-100 pb-4">
            <h2 className="text-sm font-semibold text-gray-800 sm:text-base">
              حمل‌ونقل و تحویل مطمئن‌تر
            </h2>
          </div>

          <div className="mt-4 space-y-4 text-sm leading-8 text-gray-700 sm:text-base">
            <p>
              حمل کالاهای ساختمانی به دلیل تنوع کالا، حجم و وزن بالا و شرایط
              متفاوت بارگیری و تخلیه، بخش مهمی از زنجیره تأمین است.
            </p>
            <p>
              به همین دلیل، بازارگاه تنها به اتصال مشتری و تأمین‌کننده محدود
              نمی‌شود و حمل‌ونقل و تحویل سفارش نیز بخشی از فرآیند تأمین در نظر
              گرفته شده است. هدف ما این است که با ایجاد هماهنگی بهتر میان
              تأمین کالا، حمل و تحویل، احتمال خطا و سردرگمی در این مرحله کاهش
              پیدا کند و سفارش با اطمینان بیشتری به مقصد برسد.
            </p>
          </div>
        </section>

        {/* یک زنجیره تأمین کارآمدتر */}
        <section className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5 text-justify">
          <div className="border-b border-gray-100 pb-4">
            <h2 className="text-sm font-semibold text-gray-800 sm:text-base">
              یک زنجیره تأمین کارآمدتر
            </h2>
          </div>

          <div className="mt-4 space-y-4 text-sm leading-8 text-gray-700 sm:text-base">
            <p>
              ما بازارگاه را صرفاً یک فروشگاه اینترنتی برای کالای ساختمانی
              نمی‌دانیم.
            </p>
            <p>
              هدف، ایجاد بستری است که بخش‌های مختلف فرآیند تأمین را به یکدیگر
              متصل کند؛ مشتری، تأمین‌کننده، کالا، حمل‌ونقل و خدمات پس از فروش.
            </p>
            <p>
              می‌خواهیم خرید کالای ساختمانی از فرآیندی که گاهی پراکنده،
              زمان‌بر و وابسته به ارتباطات متعدد است، به فرآیندی تبدیل شود که{" "}
              <span className="font-semibold text-gray-900">
              سریع‌تر، اقتصادی‌تر، دقیق‌تر، شفاف‌تر و قابل‌اعتمادتر
            </span>{" "}
              باشد.
            </p>
            <p>
              این مسیر برای ما از پژوهش در زنجیره تأمین آغاز شده و اکنون با
              ساخت یک بازارگاه تخصصی برای صنعت ساختمان ادامه پیدا می‌کند.
            </p>
          </div>
        </section>

        {/* Values */}
        <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="border-b border-gray-100 px-4 py-4 sm:px-5">
            <h2 className="text-sm font-semibold text-gray-800 sm:text-base">
              ارزش‌های ما
            </h2>
          </div>

          <div className="grid grid-cols-1 gap-4 p-4 sm:p-5 md:grid-cols-3">
            {values.map((item) => (
                <div
                    key={item.title}
                    className="rounded-2xl border border-gray-200 bg-gray-50/60 p-4 transition-all duration-200 hover:border-[#00AFA9]/40 hover:shadow-md"
                >
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-[#00AFA9]/10 text-[#00AFA9]">
                  <item.icon className="h-5 w-5"/>
                </span>

                  <h3 className="mt-3 text-sm font-semibold text-gray-900 sm:text-base">
                    {item.title}
                  </h3>

                  <p className="mt-2 text-sm leading-7 text-gray-600">
                    {item.desc}
                  </p>
                </div>
            ))}
          </div>
        </section>

        {/* Achievements */}
        <section className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5">
          <div className="border-b border-gray-100 pb-4">
            <h2 className="text-sm font-semibold text-gray-800 sm:text-base">
              دستاوردهای ما
            </h2>
          </div>

          <div className="mt-4 grid grid-cols-2 gap-3 md:grid-cols-4">
            {[
              {num: "-", label: "محصول فعال"},
              {num: "-", label: "تأمین‌کننده معتبر"},
              {num: "-", label: "مشتری راضی"},
              {num: "۲۴/۷", label: "پشتیبانی"},
            ].map((stat) => (
                <div
                    key={stat.label}
                    className="rounded-2xl border border-gray-200 bg-gray-50/60 p-4 text-center"
                >
                  <div className="text-base font-bold text-[#1E3A5F] md:text-lg">
                    {stat.num}
                  </div>
                  <div className="mt-1 text-xs text-gray-500 sm:text-sm">
                    {stat.label}
                  </div>
                </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div
              className="flex flex-col items-center justify-between gap-4 bg-[#00AFA9]/5 px-4 py-6 text-center sm:px-5 md:flex-row md:text-right">
            <div>
              <h3 className="text-sm font-semibold text-gray-900 sm:text-base">
                آماده همکاری با شما هستیم
              </h3>
              <p className="mt-1 text-sm text-gray-600">
                برای اطلاعات بیشتر با ما در تماس باشید.
              </p>
            </div>

            <Link
                to="/contact-us"
                className="inline-flex items-center gap-2 rounded-lg bg-[#1E3A5F] px-4 py-2 text-sm font-medium text-[#FFC107] transition-colors duration-200 hover:bg-[#2B5388]"
            >
              تماس با ما
              <FiArrowLeft className="h-4 w-4"/>
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutPage;
